import React, { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { useSelector, useDispatch } from "react-redux"
import { updateCart, updateProduct } from "../../redux/cartRedux"
import { Add, Remove } from "@mui/icons-material"
import { Link } from "react-router-dom"
import { Helmet } from "react-helmet"
// Components
import Navbar from "../../components/Navbar/Navbar"
import Footer from "../../components/Footer/Footer"
import Button from "../../components/Button/Button"
import Payment from "../../components/Payment/Payment"
import CartAddress from "../../components/CartAddress/CartAddress"
import NoUserForm from "../../components/NoUserForm/NoUserForm"
// Styles
import {
   Amount,
   AmountContainer,
   Bottom,
   Container,
   Details,
   Hr,
   Image,
   Info,
} from "./Cart.styles"
import {
   Price,
   PriceDetail,
   Product,
   ProductDetailColor,
   ProductDetail,
   ProductId,
   ProductName,
   ProductSize,
} from "./Cart.styles"
import {
   Summary,
   SummaryItem,
   SummaryItemPrice,
   SummaryItemText,
   SummaryTitle,
   Title,
   Top,
   Wrapper,
} from "./Cart.styles"
import { useTheme } from "styled-components"

const Cart = () => {
   const dispatch = useDispatch()
   const theme = useTheme()
   const { t } = useTranslation()
   const cart = useSelector((state) => state.cart)
   const user = useSelector((state) => state.user.currentUser)
   const [displayPayment, setDisplayPayment] = useState(false)
   const [displayDelivery, setDisplayDelivery] = useState(false)
   const [displayInvoice, setDisplayInvoice] = useState(false)

   useEffect(() => {
      !cart.sameAddress && setDisplayInvoice(true)
      cart.paymentMethod === "card" && setDisplayPayment(true)
   }, [cart.sameAddress, cart.paymentMethod])

   const handleQuantity = (type, productId) => {
      if (!displayPayment) {
         let cartUpdated = {
            products: [],
            totalQuantity: 0,
            amount: 0,
         }
         let products = cart.products.map((item) => ({
            ...item,
         }))
         cartUpdated.products = products
         cartUpdated.totalQuantity = cart.totalQuantity
         cartUpdated.amount = cart.amount

         if (type === "dec") {
            for (let i = 0; i < cartUpdated.products.length; i++) {
               if (cartUpdated.products[i]._id === productId) {
                  cartUpdated.totalQuantity = cartUpdated.totalQuantity - 1
                  cartUpdated.amount =
                     cartUpdated.amount - cartUpdated.products[i].unitPrice
                  if (cartUpdated.products[i].quantity > 1) {
                     cartUpdated.products[i]["quantity"] =
                        cartUpdated.products[i].quantity - 1
                  } else {
                     cartUpdated.products.splice(i, 1)
                  }
               }
            }
         } else {
            for (let i = 0; i < cartUpdated.products.length; i++) {
               if (cartUpdated.products[i]._id === productId) {
                  cartUpdated.totalQuantity = cart.totalQuantity + 1
                  cartUpdated.amount =
                     cartUpdated.amount + cartUpdated.products[i].unitPrice
                  cartUpdated.products[i]["quantity"] =
                     cartUpdated.products[i].quantity + 1
               }
            }
         }
         dispatch(updateProduct(cartUpdated))
      }
   }

   const handleCancel = (e) => {
      e.preventDefault()
      setDisplayDelivery(false)
      setDisplayPayment(false)
      dispatch(
         updateCart({
            deliveryAddress: {},
            sameAddress: true,
            paymentMethod: "",
         })
      )
   }

   return (
      <>
         <Helmet>
            <title>{t("cartPage.meta.meta_title")}</title>
            <meta name="robots" content="noindex, nofollow" />
         </Helmet>
         <Container>
            <Navbar bgImageColor="light" />
            <Wrapper>
               <Title>{t("cartPage.title.t1")}</Title>
               <Top>
                  <Link
                     to="/products"
                     style={{
                        display: "flex",
                        alignItems: "center",
                        color: "inherit",
                        textDecoration: "none",
                        width: "100%",
                     }}
                  >
                     <Button text={t("cartPage.button.b1")} width={70} />
                  </Link>
                  <Button
                     text={t("cartPage.button.b3")}
                     width={50}
                     callback={(e) => handleCancel(e)}
                  />
               </Top>
               <Bottom>
                  <Info>
                     {cart.products?.map((product, index) => (
                        <div key={index}>
                           <Product>
                              <ProductDetail>
                                 <Image
                                    src={
                                       theme.name === "dark"
                                          ? product.imagesDark[0]
                                          : product.imagesLight[0]
                                    }
                                 />
                                 <Details>
                                    <ProductName>
                                       <b>{t("favorites.label.l1")} : </b>
                                       {product.model}
                                    </ProductName>
                                    <ProductId>
                                       <b>{t("favorites.label.l2")} : </b>
                                       {product.code}
                                    </ProductId>
                                    {product.detailedColor.length <= 2 ? (
                                       <></>
                                    ) : (
                                       <ProductDetailColor>
                                          <b>{t("favorites.label.l3")} : </b>
                                          {product.detailedColor}
                                       </ProductDetailColor>
                                    )}
                                    <ProductSize>
                                       <b>{t("favorites.label.l4")} : </b>{" "}
                                       {product.detailedColor.length <= 2
                                          ? product.detailedColor
                                          : product.size.replace(
                                               "undefined - undefined",
                                               "unique"
                                            )}
                                    </ProductSize>
                                 </Details>
                              </ProductDetail>
                              <PriceDetail>
                                 <AmountContainer>
                                    <Remove
                                       color="primary"
                                       onClick={() =>
                                          handleQuantity("dec", product._id)
                                       }
                                       style={{ cursor: "pointer" }}
                                    />
                                    <Amount>{product.quantity}</Amount>
                                    <Add
                                       color="primary"
                                       onClick={() =>
                                          handleQuantity("inc", product._id)
                                       }
                                       style={{ cursor: "pointer" }}
                                    />
                                 </AmountContainer>
                                 <Price>
                                    {product.unitPrice * product.quantity} €
                                 </Price>
                              </PriceDetail>
                           </Product>
                           <Hr />
                        </div>
                     ))}
                  </Info>
                  <Summary>
                     <SummaryTitle>{t("cartPage.title.t2")}</SummaryTitle>
                     <SummaryItem>
                        <SummaryItemText>
                           {t("cartPage.label.l1")}
                        </SummaryItemText>
                        <SummaryItemPrice>{cart.amount} €</SummaryItemPrice>
                     </SummaryItem>
                     <SummaryItem>
                        <SummaryItemText>
                           {t("cartPage.label.l2")}
                        </SummaryItemText>
                        <SummaryItemPrice>0 €</SummaryItemPrice>
                     </SummaryItem>
                     <SummaryItem type="total">
                        <SummaryItemText>
                           {t("cartPage.label.l3")}
                        </SummaryItemText>
                        <SummaryItemPrice>{cart.amount} €</SummaryItemPrice>
                     </SummaryItem>
                     <Button
                        text={t("cartPage.button.b2")}
                        callback={() => {
                           setDisplayDelivery(true)
                           setTimeout(() => {
                              window.scrollTo({
                                 top: document.body.scrollHeight,
                                 behavior: "smooth",
                              })
                           }, 100)
                        }}
                        disabled={cart.amount === 0}
                     />
                  </Summary>
               </Bottom>
               {displayDelivery && !user ? <NoUserForm /> : null}
               <CartAddress
                  display={displayDelivery && user !== null}
                  role="delivery"
                  validated={displayInvoice || displayPayment}
               />
               <CartAddress
                  display={displayInvoice}
                  role="invoice"
                  validated={displayPayment}
               />
               <Payment display={displayPayment} amount={cart.amount} />
            </Wrapper>
            <Footer />
         </Container>
      </>
   )
}

export default Cart
